import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://cetcusa.com";
const DEFAULT_IMAGE = `${SITE}/og-image.jpg`;

/**
 * Per-route <head> tags. Reaches crawlers on the deployed app when
 * the "Enable Search Engine Crawling" toggle is ON (prerender).
 */
export default function Seo({ title, description, path = "/", image = DEFAULT_IMAGE, type = "website" }) {
  const url = `${SITE}${path}`;
  const fullTitle = title;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
